

import {Injectable,OnInit} from '@angular/core';
import {AnonymousSubject, Observable} from 'rxjs/Rx';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AlertsService} from './alerts.service';
import {Router} from '@angular/router';
// import * as XLSX from 'xlsx';

import {
  GET_CLIENT_CONFIG,
  WHATSAPP_SEND_TOKEN
} from '../../config';
import {DataService} from './data.service';
// import * as moment from 'moment';
// import { time } from 'highcharts';
import { ApiService } from './api.service';

@Injectable()
export class XlsxServiceService {
  
  // private utcOffset = '+5.30';
  // public today = moment().utc();
  // console.log(today)

  constructor(private http: HttpClient,
              private alertsService: AlertsService,
              private router: Router, private dataservice : DataService,
              private apiService: ApiService ) {
  }


  export(data:any,filename) {
    // /* generate worksheet */
    // const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

    // /* generate workbook and add the worksheet */
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // /* save to file */
    // XLSX.writeFile(wb, filename);
  }

  // onFileChange(evt: any) {
  //   /* wire up file reader */
  //   const target: DataTransfer = <DataTransfer>evt.target;
  //   if (target.files.length !== 1) throw new Error('Cannot use multiple files');
  //   const reader: FileReader = new FileReader();
  //   reader.onload = (e: any) => {
  //     /* read workbook */
  //     const bstr: string = e.target.result;
  //     const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

  //     /* grab first sheet */
  //     const wsname: string = wb.SheetNames[0];
  //     const ws: XLSX.WorkSheet = wb.Sheets[wsname];

  //     /* save data */
  //     this.data = <AOA>XLSX.utils.sheet_to_json(ws, { range: "A1:B1",header: 1 });
  //     console.log(this.data);
  //   };
  //   reader.readAsBinaryString(target.files[0]);
  // }
 

  
  
}

